import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SettingSelectors } from '@app/store/setting/setting.selectors';
import { Store } from '@ngxs/store';
import { ApiService } from './api.service';
import { KidsMenuName } from '@app/models/menu.model';

@Injectable({
  providedIn: 'root',
})
export class AccesslogService {
  constructor(
    private apiService: ApiService,
    private router: Router,
    private store: Store
  ) {}

  login() {
    const { userAgent, platform } = window.navigator;
    const { width, height } = window.screen;
    const screenSize = `${width}×${height}`;
    const content = `platform: ${platform}, screenSize: ${screenSize}, userAgent: ${userAgent}`;
    const payload = { accstyp: 0, content };
    this.apiService.setAccesslog(payload).subscribe();
  }

  logout() {
    const displayName = this.getDisplayName();
    const payload = { accstyp: 1, displayName };
    this.apiService.setAccesslog(payload).subscribe();
  }

  getDisplayName(): string {
    const url = this.router.url;
    const menuList = this.store.selectSnapshot(SettingSelectors.menuList);
    const pageList = menuList.flatMap((menu) =>
      menu.menus.flatMap(({ name, path, chkTtls }) => {
        if (chkTtls && chkTtls.length > 0) {
          return chkTtls.map(({ name, path }) => ({ name, path }));
        }
        return { name, path };
      })
    );
    const page = pageList.find(
      ({ path }) => path && path !== '' && url.startsWith(path)
    );
    if (!page) {
      return this.getScheduleDisplay() || this.getKidsDisplayName('');
    }
    return this.getKidsDisplayName(page?.name ?? '');
  }

  getScheduleDisplay() {
    const url = this.router.url;
    const isWebView = this.store.selectSnapshot(SettingSelectors.isWebView);
    if (!isWebView) return null;
    if (url.startsWith('/webview/home/daily')) return KidsMenuName.DAILY;
    return null;
  }


  getKidsDisplayName(name: string): string {
    return `KIDS_${name}`;
  }
}
